<template>
  <v-card outlined class="card-center pb-2">
    <validation-observer v-slot="{ invalid }">
      <v-container class="px-4 py-4" fluid>
        <v-row dense class="mb-1">
          <v-col cols="4">
            <FileInput v-model="file" :label="$t('ELE0081')" accept=".txt, .csv" rules="ext:txt,csv" required />
          </v-col>
          <v-col>
            <BtnImport class="mt-1" @click="onClickImport" :disabled="invalid" />
          </v-col>
          <v-col>
            <BtnCsvDownload :label="$t('ELE0076')" fileTitle="import_index" :items="emptyCsvContents" />
          </v-col>
          <v-col>
            <Btn :label="$t('ELE0082')" @click="onClickSearchInspIndex" />
          </v-col>
        </v-row>
        <v-row v-if="isImported">
          <v-col>
            <v-card outlined>
              <v-card-title>
                {{ $t('ELE0077') }}
              </v-card-title>
              <v-card v-if="isSuccessImported" outlined class="mx-auto" color="green lighten-5" width="600px">
                <v-card-title>
                  <v-row>
                    <v-col class="d-flex flex-row space-between">
                      <span class="mx-3">
                        <v-avatar color="green" size="36">
                          <v-icon color="white">mdi-check-bold</v-icon>
                        </v-avatar>
                      </span>
                      <span class="pt-1">
                        {{ $t('MSG0038', { p0: successLineCount }) }}
                      </span>
                    </v-col>
                  </v-row>
                </v-card-title>
              </v-card>
              <v-card v-if="errorList.length > 0" outlined class="mx-auto" color="red lighten-5" width="600px">
                <v-card-title class="text-h5 justify-center">
                  {{ $t('MSG0039') }}
                </v-card-title>
                <v-card-text class="text-h6 font-weight-normal black--text">
                  <v-row>
                    <v-col class="d-flex flex-row">
                      <span class="mx-3">
                        <v-avatar color="red" size="36" class="px-2">
                          <v-icon color="white">mdi-exclamation-thick</v-icon>
                        </v-avatar>
                      </span>
                      <span class="pt-1">{{ $t('MSG0040', { p0: errorLineCount }) }}</span>
                      <v-spacer />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
              <v-card-text>
                <v-data-table v-if="errorList.length > 0" dense :headers="headers" :items="errorList">
                  <template v-slot:item.text="{ item }">
                    <div class="py-1" style="white-space: pre">{{ item.text }}</div>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </validation-observer>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import { ValidationObserver } from 'vee-validate'
import { API } from '@/plugins/api'

import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'
import Loading from '@/mixin/loading-utils.js'

import Btn from '@/components/atoms/base/button/Btn'
import BtnImport from '@/components/atoms/button/BtnImport'
import FileInput from '@/components/atoms/base/file/FileInput'
import BtnCsvDownload from '@/components/atoms/button/BtnCsvDownload'

export default {
  name: 'ImpInspIndexForm',

  mixins: [APIUtils, Message, Loading],

  components: {
    ValidationObserver,
    Btn,
    BtnImport,
    FileInput,
    BtnCsvDownload,
  },

  data() {
    return {
      file: null,
      errorList: [],
      successLineCount: '',
      errorLineCount: '',
      isImported: false,
      isSuccessImported: false,
      headers: [
        { text: this.$t('ELE0084'), value: 'line', divider: true, width: '125', align: 'end' },
        { text: this.$t('ELE0085'), value: 'text' },
      ],
      headerData: {
        inspCats1: '',
        inspCats2: '',
      },
    }
  },

  computed: {
    ...mapGetters(['userCd']),
    emptyCsvContents: {
      get() {
        return [
          {
            [this.$t('ELE0394')]: '',
            [this.$t('ELE0031')]: '',
            [this.$t('ELE0049')]: '',
            [this.$t('ELE0050')]: '',
            [`${this.$t('ELE0007')}1 (${this.headerData.inspCats1})`]: '',
            [`${this.$t('ELE0007')}2 (${this.headerData.inspCats2})`]: '',
            [this.$t('ELE0051')]: '',
            [this.$t('ELE0052')]: '',
            [this.$t('ELE0053')]: '',
            [this.$t('ELE0054')]: '',
          },
        ]
      },
    },
  },

  methods: {
    onClickImport() {
      this.errorList = []
      this.isImported = true
      this.isSuccessImported = false
      try {
        this.csvToJson(this.checkIndex)
        this.file = null
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0003', { p0: this.$('ELE0083') })))
      }
    },
    onClickSearchInspIndex() {
      this.$router.push({ name: 'T02' }).catch()
    },
    csvToJson(callback) {
      this.$papa.parse(this.file, {
        skipEmptyLines: true,
        complete: function (results) {
          callback(results.data)
        },
      })
    },
    async checkIndex(csvData) {
      try {
        this.startLoading()
        if (csvData[0].length != 10) {
          this.setErrorMessage(this.$t('MSG0028'))
          return
        }

        const items = this.getItems(csvData)
        let body = {
          userCd: this.userCd,
          items: items,
        }
        const elements = await API.post('/inspIndex/checkInspIndexes', body)
        if (elements.isResult) {
          this.successLineCount = elements.successLineCount
          await this.registerBox(items)
        } else {
          this.errorLineCount = elements.errorLineCount
          elements.errorMessages.forEach((element) => {
            const item = {
              line: element.lineNo + 2, // Excelの行数と合わせるため+2
              text: element.bodies.join('\r\n'),
            }
            this.errorList.push(item)
          })
        }
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0003', { p0: this.$t('ELE0083') })))
      } finally {
        this.stopLoading()
      }
    },
    async registerBox(items) {
      try {
        let body = {
          userCd: this.userCd,
          items: items,
        }
        await API.post('/inspIndex/registerInspIndexes', body)
        this.setSuccessMessage(this.$t('MSG0056'))
        this.isSuccessImported = true
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0003', { p0: this.$('ELE0083') })))
      }
    },
    getItems(csvData) {
      let items = []
      for (let index = 1; index <= csvData.length - 1; index++) {
        let item = {}
        item.manufacturerCd = csvData[index][0]
        item.partCd = csvData[index][1]
        item.lotNo = csvData[index][2]
        item.lotQty = csvData[index][3]
        item.inspCat1 = csvData[index][4]
        item.inspCat2 = csvData[index][5]
        item.moldNo = csvData[index][6] ? csvData[index][6] : null
        item.mmmmApplNo = csvData[index][7] ? csvData[index][7] : null
        item.matlSpec = csvData[index][8] ? csvData[index][8] : null
        item.remarks = csvData[index][9] ? csvData[index][9] : null
        items.push(item)
      }
      return items
    },
    async createInspCats1Header() {
      try {
        const elements = await API.get('/master/inspCats/cat1', { validOnly: true })
        let items = []
        for await (const e of elements) {
          items.push(`${e.inspCat}:${e.inspCatName}`)
        }
        this.headerData.inspCats1 = items.join('/')
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0003', { p0: `${this.$t('ELE0007')} 1` })))
      }
    },
    async createInspCats2Header() {
      try {
        const elements = await API.get('/master/inspCats/cat2', { validOnly: true })
        let items = []
        for await (const e of elements) {
          items.push(`${e.inspCat}:${e.inspCatName}`)
        }
        this.headerData.inspCats2 = items.join('/')
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0003', { p0: `${this.$t('ELE0007')} 2` })))
      }
    },
  },
  async mounted() {
    try {
      this.startLoading()
      await this.createInspCats1Header()
      await this.createInspCats2Header()
    } finally {
      this.stopLoading()
    }
  },
}
</script>
